<app-navbar title="Skrzynka odbiorcza"></app-navbar>
<div class="m-3">
	<mat-expansion-panel [expanded]="true" class="mb-3">
		<mat-expansion-panel-header>
			<mat-panel-title
				><mat-panel-title
					><i class="fa fa-filter"></i><span class="ms-2 font-weight-600">Filtry</span></mat-panel-title
				></mat-panel-title
			>
		</mat-expansion-panel-header>
		<app-message-filters #filtersComponentRef [paginator]="paginator"></app-message-filters>
	</mat-expansion-panel>
	<app-message-tabs></app-message-tabs>
	<mat-paginator
		class="d-flex justify-content-start message-paginator"
		[pageSizeOptions]="[10, 15, 20, 50]"
		[length]="service.resultsLength"
	>
	</mat-paginator>
</div>
